import Map from '../../../../../../../common/components/map'
import React from 'react'
import _ from 'lodash';

export default function AgentTrackerComponent({ selectShipping, location }: any) {
  const image = require('../../../../../../../assets/img/delivery.png')
  const originGps = selectShipping?.fulfillments[0]?.start?.location?.gps;
  const destinationGps = selectShipping?.fulfillments[0]?.end?.location?.gps;
  const latLongData: any = _.split(originGps, ',');

  return (
    <>

      <div className="w-full bg-white px-5 text-gray-800">

        <div className="w-full">
          <Map
            lat={location.Latitude || latLongData[0]}
            lng={location.Longitude || latLongData[1]}
            height={'420px'}
            zoom={15}
            icon={image}
            showInfoWindow={false}
            isRouteDirection={true}
            originLocation={originGps}
            destinationLocation={destinationGps}
          />

        </div>
      </div>

    </>
  )
}